import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import { ref, onMounted } from "vue";
import informationService from "@/utils/information";
import PC from "./components/pc";
import Mobile from "./components/mobile";
export default /*@__PURE__*/Object.assign({
  name: "DiscountMembership"
}, {
  __name: 'index',
  setup(__props) {
    const isMobile = ref(false);
    onMounted(() => {
      isMobile.value = informationService.isMobile();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [isMobile.value ? (_openBlock(), _createBlock(_unref(Mobile), {
        key: 0
      })) : (_openBlock(), _createBlock(_unref(PC), {
        key: 1
      }))]);
    };
  }
});